import { Component, OnInit, ViewChildren, Output, EventEmitter } from '@angular/core';
import { LCAAddNew } from '../../../data/models/lcaaddnew.model';
import { environment } from '../../../../environments/environment';
import { ReferenceLibraryService } from '../../../services/referenceLibrary.service';
import { ReferenceLibrary } from '../../../data/models/referenceLibrary.model';
import { PetitionerService } from '../../../services/petitioner.service';
import { LcaService } from '../../../services/lca.service';
import { UploadDocumentService } from '../../../services/upload-document.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import {MatAccordion} from '@angular/material/expansion';
import { AttorneyService } from 'src/app/services/attorney.service';
import { CountryApiService } from '../../petitioner/services/country.service';
import { acceptedFileTypes } from 'app-models';
@Component({
  selector: 'app-view-lca',
  templateUrl: './view-lca.component.html',
  styleUrls: ['./view-lca.component.scss']
})
export class ViewLcaComponent implements OnInit {
  lca = new LCAAddNew({});
  visaTypeList: ReferenceLibrary[];
  listCompany: any;
  listStates = [];
  listCountry = [];
  listUploadedFiles = [];
  assignmentList = [];
  employerInfo: any;
  lcaList: any;
  lcaId: any;
  petitionerId: any;
  showFileUploadSection: boolean = false;
  enableReadOnlyMode: boolean = false;
  expandPanel = false;
  envPath: any;
  lcaObj: any;
  employerStateName: string;
  userType: string;
  petitionerInfo: any;
  companyListAssociatedWithAttorney = [];
  @ViewChildren(MatAccordion) accordion: MatAccordion;
  @Output() enableEditSection: EventEmitter<any> = new EventEmitter();
  DisplayString;

  configurations = {
    inputMultipleFlag: false,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'LCADOC',
    entityId: 0,
    fileCategory: 'LCA',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'LCADOC',
    useCase: 'company',
    useCaseId: parseInt(sessionStorage.getItem('companyId'))
  };

  constructor(private router: Router, private route: ActivatedRoute,
    private referenceLibraryService: ReferenceLibraryService,
    private petitionerService: PetitionerService,
    private uploadDocumentService: UploadDocumentService,
    private toastr: ToastrService,
    private lcaApis: LcaService,
    private apiService: CountryApiService,
    private attorneyService: AttorneyService) {
    this.visaTypeList = [];
    this.DisplayString =  new Map([
      ['HOUR', 'Hour'],
      ['WEEK', 'Week'],
      ['BIWEEKLY', 'Bi-Weekly'],
      ['MONTH', 'Month'],
      ['YEAR', 'Year'],
      ['WAGELVL1', 'I'],
      ['WAGELVL2', 'II'],
      ['WAGELVL3', 'III'],
      ['WAGELVL4', 'IV'],
      ['NOTAPPLCBL','N/A']
    ]);
  }

  ngOnInit() {
    this.onChangeCountry('USA');
    this.userType = sessionStorage.getItem('userTypeRole');
    this.envPath = environment.docs;
    this.referenceLibraryService.getReferenceData('VISATYP').subscribe((response: ReferenceLibrary[]) => {
      this.visaTypeList = response;
      if(this.employerInfo){
        this.employerInfo.feiNo = '';  // type error correction 
        this.employerInfo.naicsCode = ''; // type error correction 
      } 
    });



    if (sessionStorage.getItem('companyId')) {
      if (this.userType === 'Attorney') {
        this.getCompanyListAssociatedWithAttorney()
        this.lca.id = sessionStorage.getItem('lcaId') ? parseInt(sessionStorage.getItem('lcaId')) : null;
      } else {
        this.lcaApis.companyHierarchy(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
          this.listCompany = data;
          if (this.lca.companyId) {
            this.employerInfo = this.listCompany.find(x => x.id === this.lca.companyId);
          }
          else {
            this.employerInfo = data[0];
            this.lca.companyId = data[0].id;
          }

          this.lca.id = sessionStorage.getItem('lcaId') ? parseInt(sessionStorage.getItem('lcaId')) : null;
        });
      }
    }
 
    if (sessionStorage.getItem('lcaId')) {
      this.petitionerService.getLcaDetailsById(parseInt(sessionStorage.getItem('lcaId'))).subscribe(data => {
        this.configurations.entityId = parseInt(sessionStorage.getItem('lcaId'));
        //this.configurations.useCaseId = parseInt(sessionStorage.getItem('lcaId'));
        this.configurations = Object.assign({}, this.configurations);
        if (data && data.lcaApplication) {
          data.lcaApplication.companyId = data.lcaApplication.company?.id;
          data.lcaApplication.visaType = data.lcaApplication.visaType?.code;
        }
        this.lca = data['lcaApplication'];
        this.lca.placeOfEmployments = data['placeList'];
        this.listUploadedFiles = data['documents'];
        this.assignmentList = data['assignmentList'];

        this.lca.placeOfEmployments.forEach((item) => {
          this.listStates.forEach((data) => {
            if(data.stateProvinceCode === item.addressDTO.stateProvinceCode){
              item.addressDTO.stateProvinceName = data.stateProvinceName;
            }
          })
        })
        let newNaicsCodeText = data?.lcaApplication?.companyNaicsCode+"--"+data?.lcaApplication?.companyNaicsTitle;
        if (this.userType === 'Attorney') {
          if(!this.petitionerInfo){
            this.petitionerInfo = {};
          }
          this.petitionerInfo['newNaicsCode'] = newNaicsCodeText;
          this.petitionerInfo['feiNo'] = data.lcaApplication.company.feiNo;
        } else {
          this.employerInfo.newNaicsCode = newNaicsCodeText;
          this.employerInfo.feiNo = data.lcaApplication.company.feiNo;
        }
        

        this.lcaObj = this.lca
        //this.lca.socCode = data.lcaApplication.socCode 
        //  console.log("inside this.lca",this.lca)

        if (this.lca['status'] && this.lca['status']['code'] !== "LCAASSIGN") {
          this.enableReadOnlyMode = false;
        } else {
          this.enableReadOnlyMode = true;
        }
        // this.enableLCAid.emit(this.lca);
        let countrycode = this.lca['company']?.address[0]?.countryCode?.countryCode;
        //  console.log("$$$$ countrycode",countrycode)
        if (countrycode) {
          this.getStatesList(countrycode)
        }

        //   this.getUpolodedFiles();
        
      });
    }


  }

  getStatesList(countryCode) {
    this.lcaApis.getStates(countryCode).subscribe((states: []) => {
      //  console.log("states",states)
      this.listStates = states;
      const stateCode = this.userType === 'Attorney' ? this.petitionerInfo?.petitionerRegisteredAddress?.stateProvinceCode : this.employerInfo?.address[0]?.stateProvinceCode;
      this.getStateName(stateCode, 'Current')
    })
  }


  selectedCompany(id) {
    if (this.userType === 'Attorney') {
      this.petitionerInfo = this.companyListAssociatedWithAttorney.find(x => x.petitionerId === parseInt(id));
      this.lca.companyId = id;
    } else {
      this.employerInfo = this.listCompany.find(x => x.id === parseInt(id));
      this.lca.companyId = id;
    }
  }

  getCompanyListAssociatedWithAttorney() {
    const reqJson = {
      searchText: '',
      searchCriteria: '',
      sortBy: '',
      sortOrder: '',
      pageNumber: 0,
      recordsPerPage: 0
    };

    this.attorneyService.getClientsList(parseInt(sessionStorage.getItem('companyId')), reqJson).subscribe((response: any) => {
      if (response) {
        //console.log("attorney",response)
        this.companyListAssociatedWithAttorney = response['petetionerList'];
        if (this.lca.companyId) {
          this.petitionerInfo = this.companyListAssociatedWithAttorney.find(x => x.petitionerId === this.lca.companyId);
        } else {
          this.petitionerInfo = this.companyListAssociatedWithAttorney[0];
          this.lca.companyId = this.companyListAssociatedWithAttorney[0].petitionerId;
        }


      }


    });

  }


  backToLCAList() {
    this.router.navigate(['../lca'], { relativeTo: this.route });
  }

  enableEditMode() {
    this.enableReadOnlyMode = false;
    this.enableEditSection.emit(true)

  }
  /* getting value from withdrwa-lca to hide the edit button */
  hideEditButtonHandler(obj) {
    this.lca.status.code = obj.status.code;
  }

  toggleExpansion() {
    this.expandPanel = !this.expandPanel;
  }

  getStateName(stateProvinceCodes, stateIndex) {
    switch (stateIndex) {
      case 'Current':
        this.employerStateName = this.listStates.find(x => x.stateProvinceCode === stateProvinceCodes).stateProvinceName;
        break;

    }
  }

  onChangeCountry(countryCode: string) {
    this.apiService.getStates(countryCode)
    .subscribe((states: []) => {
      this.listStates = states;
    });
  }
  
  getDisplayString(code){
   return this.DisplayString.get(code);
  }

}



